import PropTypes from 'prop-types';
import CardMedia from '@material-ui/core/CardMedia';
import {Avatar, Tooltip, List, ListItem, ListItemText} from '@material-ui/core';
import {GetApp as GetAppIcon, Photo as PhotoIcon} from '@material-ui/icons';
import red from '@material-ui/core/colors/red';

const Media = (props) => {
  const {media} = props;

  if (media) {
    if (media.image) {
      return <CardMedia component="img" sx={{width: 151}} image={media.url} />;
    }

    return (
      <List dense>
        <Tooltip title="Download File">
          <ListItem component="a" button href={media.url} target="_blank">
            <Avatar>
              <GetAppIcon />
            </Avatar>
            <ListItemText primary="Click to download file" />
          </ListItem>
        </Tooltip>
      </List>
    );
  }

  return (
    <List dense>
      <ListItem>
        <Avatar style={{backgroundColor: red['500']}}>
          <PhotoIcon />
        </Avatar>
        <ListItemText primary="No Media" />
      </ListItem>
    </List>
  );
};

Media.propTypes = {
  media: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.bool,
    length: PropTypes.number,
    mime: PropTypes.string,
    s3key: PropTypes.string,
    url: PropTypes.string,
  }),
};

Media.defaultProps = {
  media: null,
};

export default Media;
